import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = React.useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", window.location.pathname);
        await checkAuth();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/login"), 2000);
      }
    })();
  }, [location, navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-3">
        <div className="h-12 w-12 mx-auto rounded-full border-4 border-primary border-t-transparent animate-spin" />
        <p className="text-muted-foreground">{error ? "Falha no login. Redirecionando..." : "Entrando..."}</p>
      </div>
    </div>
  );
}
